export default "__VITE_ASSET__Cglfeg1d__"